import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, KnowledgeBaseItemSchema, UpdateKnowledgeBaseItem } from "schema"
import { z } from "zod"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

type Response = DataResponse<z.infer<typeof KnowledgeBaseItemSchema>>

const FrontendUpdateKnowledgeBaseItemSchema = UpdateKnowledgeBaseItem.omit({
  content: true,
}).extend({
  content: z.union([z.string(), z.instanceof(FileList), z.null()]),
})

export function useUpdateKnowledgeBaseMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      data: z.input<typeof FrontendUpdateKnowledgeBaseItemSchema> & { id: string },
    ) => {
      const response = await axios.put<Response>(`/knowledgeBase/${data.id}`, data)

      return response.data.data
    },
    onSuccess: (updatedItem) => {
      queryClient.setQueriesData(
        { queryKey: [knowledgeBaseQuery().queryKey.at(0)] },
        (oldData: z.infer<typeof KnowledgeBaseItemSchema>[] | undefined) => {
          if (!oldData) return oldData
          return oldData.map((item) =>
            item.id.toString() === updatedItem.id.toString() ? updatedItem : item,
          )
        },
      )
    },
  })
}
